/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RelationshipTypeModel } from '../../models/relationship-type-model';

export interface RelationshipTypeIdGet$Params {
  id: string;
}

export function relationshipTypeIdGet(http: HttpClient, rootUrl: string, params: RelationshipTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<RelationshipTypeModel>> {
  const rb = new RequestBuilder(rootUrl, relationshipTypeIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<RelationshipTypeModel>;
    })
  );
}

relationshipTypeIdGet.PATH = '/RelationshipType/{id}';
